// extracted by mini-css-extract-plugin
module.exports = {"customInfinitscroll":"TrashFileContainer_customInfinitscroll__2EvL_","textEmpty":"TrashFileContainer_textEmpty__3P7Gb"};